import { render, staticRenderFns } from "./shop_goods.vue?vue&type=template&id=9af0e712&scoped=true&"
import script from "./shop_goods.vue?vue&type=script&lang=js&"
export * from "./shop_goods.vue?vue&type=script&lang=js&"
import style0 from "./shop_goods.vue?vue&type=style&index=0&id=9af0e712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af0e712",
  null
  
)

export default component.exports